export default {
  en: {
    /** エラーメッセージ */
    download: {
      not_found_error: 'This URL cannot be found.',
      survey_error:
        'This document can only be downloaded when answering a survey.',
      document_level_error:
        'Failed to download document. Please try again later.'
    },
    /** 国選択 */
    CountryRegion: {
      title: 'Country / Region',
      description: 'Please select your country or region.',
      emptyItem: '-- Select --',
      redirectLink: 'https://www.ssi.shimadzu.com/'
    },
    /** マニュアル同意 */
    ManualModal: {
      title: 'Terms of use',
      sub_title:
        'Please read and agree to the following terms before downloading instruction manuals or other documents from this website.',
      description1:
        'Instruction manuals are intended for customers who have purchased our products and are written with those users in mind.We may not be able to answer inquiries about publicly available manuals etc. from those who have not purchased products from us.',
      description2:
        'Not all Shimadzu instruction manuals and published documents are available for download.',
      description3:
        'The contents of instruction manuals may be altered without notice due to updated product specifications, etc.The version of the manual available for download may differ from the version packaged with the product.',
      description4:
        'To read about how downloaded materials may be used, please refer to the terms and conditions for use of this website.',
      description4LinkPrefix: '',
      description4Link: 'https://www.shimadzu.com/terms/index.html',
      description5:
        'This free download service may be suspended or altered without prior notice.',
      description6:
        'In order to download manuals, users must first be registered for MYPAGE.',
      button: {
        agree: 'Agree and Continue',
        cancel: 'Cancel'
      }
    }
  },
  'zh-hant': {
    /** 国選択 */
    CountryRegion: {
      title: '國家/地區',
      description: '請選擇您所在的國家/地區。',
      emptyItem: '-- 選擇 --',
      redirectLink: 'https://www.ssi.shimadzu.com/'
    },
    /** マニュアル同意 */
    ManualModal: {
      title: 'Terms of use',
      sub_title:
        'Please read and agree to the following terms before downloading instruction manuals or other documents from this website.',
      description1:
        'Instruction manuals are intended for customers who have purchased our products and are written with those users in mind.We may not be able to answer inquiries about publicly available manuals etc. from those who have not purchased products from us.',
      description2:
        'Not all Shimadzu instruction manuals and published documents are available for download.',
      description3:
        'The contents of instruction manuals may be altered without notice due to updated product specifications, etc.The version of the manual available for download may differ from the version packaged with the product.',
      description4:
        'To read about how downloaded materials may be used, please refer to the terms and conditions for use of this website.',
      description4LinkPrefix: '',
      description4Link: 'https://www.shimadzu.com/terms/index.html',
      description5:
        'This free download service may be suspended or altered without prior notice.',
      description6:
        'In order to download manuals, users must first be registered for MYPAGE.',
      button: {
        agree: 'Agree and Continue',
        cancel: 'Cancel'
      }
    }
  },
  ja: {
    /** エラーメッセージ */
    download: {
      not_found_error: 'URL が見つかりません',
      survey_error:
        'このドキュメントは、アンケートに回答した場合にのみダウンロードできます',
      document_level_error:
        'コンテンツをダウンロードできませんでした。時間をおいて再度アクセスしてください。'
    },
    /** 国選択 */
    CountryRegion: {
      title: '国・地域',
      description: '国または地域を選択してください。',
      emptyItem: '-- 選択 --',
      redirectLink: 'https://www.ssi.shimadzu.com/'
    },
    /** マニュアル同意 */
    ManualModal: {
      title: 'ご利用上の注意',
      sub_title:
        '本ウェブサイトにおける取扱説明書等のダウンロードサービスは、下記注意事項をご確認の上、ご利用ください。',
      description1:
        '取扱説明書は、製品をご購入いただいたお客様のための資料であり、製品のご使用者がお読みになることを想定しています。このサービスで公開している取扱説明書について、製品を購入されたお客様以外からのお問い合わせにはお応えできない場合がありますことをご了承ください。',
      description2:
        '本サービスは、当社製品の取扱説明書、付属印刷物等のすべてを網羅するものではありません。',
      description3:
        '取扱説明書の内容は、製品の仕様変更などで予告なく変更される場合があります。このサービスで提供している取扱説明書の内容は、製品本体に同梱されている取扱説明書の内容と異なる場合があります。',
      description4:
        '本サービスにおいて提供される取扱説明書等の情報の取り扱いにつきましては、ウェブサイトご利用条件をご確認ください。',
      description4LinkPrefix: 'ご利用条件：',
      description4Link: 'https://www.shimadzu.co.jp/attention/index.html',
      description5:
        '本サービスは予告なく中止または内容を変更する場合があります',
      description6:
        '取扱説明書等のダウンロードには、初めに My SHIMADZU for Analytical への登録が必要になります。（一部除く）',
      button: {
        agree: '続行する',
        cancel: 'キャンセル'
      }
    }
  },
  es: {
    /** エラーメッセージ */
    download: {
      not_found_error: 'No se encuentra esta URL.',
      survey_error:
        'Este documento solo se puede descargar al responder una encuesta.',
      document_level_error:
        'No se pudo descargar el documento. Por favor, inténtelo de nuevo más tarde.'
    },
    /** 国選択 */
    CountryRegion: {
      title: 'País / Región',
      description: 'Seleccione su país o región.',
      emptyItem: '--Escoger--',
      redirectLink: 'https://www.ssi.shimadzu.com/'
    },
    /** マニュアル同意 */
    ManualModal: {
      title: 'Condiciones de uso',
      sub_title:
        'Lea y acepte los siguientes términos antes de descargar manuales de instrucciones u otros documentos de este sitio web.',
      description1:
        'Los manuales de instrucciones están destinados a los clientes que han comprado nuestros productos y están escritos pensando en esos usuarios. Es posible que no podamos responder consultas sobre manuales disponibles públicamente, etc. de aquellos que no nos han comprado productos.',
      description2:
        'No todos los manuales de instrucciones de Shimadzu y documentos publicados están disponibles para su descarga.',
      description3:
        'El contenido de los manuales de instrucciones puede ser alterado sin previo aviso debido a especificaciones actualizadas del producto, etc. La versión del manual disponible para descargar puede diferir de la versión empaquetada con el producto.',
      description4:
        'Para leer sobre cómo se pueden usar los materiales descargados, consulte los términos y condiciones de uso de este sitio web.',
      description4LinkPrefix: '',
      description4Link: 'https://www.shimadzu.com/terms/index.html',
      description5:
        'Este servicio de descarga gratuita puede ser suspendido o alterado sin previo aviso.',
      description6:
        'Para descargar manuales, los usuarios primero deben estar registrados en MYPAGE.',
      button: {
        agree: 'Acordar y continuar',
        cancel: 'Cancelar'
      }
    }
  },
  'pt-br': {
    /** エラーメッセージ */
    download: {
      not_found_error: 'A URL não pode ser encontrada',
      survey_error:
        'Este documento só pode ser baixado ao responder a uma pesquisa.',
      document_level_error:
        'Falha ao baixar o documento. Por favor, tente novamente mais tarde.'
    },
    /** 国選択 */
    CountryRegion: {
      title: 'País / Região',
      description: 'Selecione seu país ou região..',
      emptyItem: '-- Selecione --',
      redirectLink: 'https://www.ssi.shimadzu.com/'
    },
    /** マニュアル同意 */
    ManualModal: {
      title: 'Termos de uso',
      sub_title:
        'Por favor, leia e concorde com os termos antes de baixar manuais de instruções ou outros documentos deste site.',
      description1:
        'Os manuais de instruções destinam-se a clientes que compraram nossos produtos e são escritos pensando nesses usuários. Talvez não possamos responder a perguntas sobre manuais disponíveis publicamente, etc., daqueles que não compraram produtos da Shimadzu.',
      description2:
        'Nem todos os manuais de instruções Shimadzu e documentos publicados estão disponíveis para download.',
      description3:
        'O conteúdo dos manuais de instruções pode ser alterado sem aviso prévio devido a especificações atualizadas do produto, etc. A versão do manual disponível para download pode diferir da versão embalada com o produto.',
      description4:
        'Para ler sobre como os materiais baixados podem ser usados, consulte os termos e condições de uso deste site.',
      description4LinkPrefix: '',
      description4Link: 'https://www.shimadzu.com/terms/index.html',
      description5:
        'Este serviço de download gratuito pode ser suspenso ou alterado sem aviso prévio.',
      description6:
        'Para baixar os manuais, os usuários devem primeiro estar registrados no MYPAGE.',
      button: {
        agree: 'Aceite para continuar',
        cancel: 'Cancelar'
      }
    }
  }
}
